export function SmallApartmentBuildingsHero() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/80d929959d0c4b7d9626f3a38cfa4878.jpg"
          alt="Small Apartment Buildings We Buy"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl lg:text-6xl font-bold mb-6">
          We Buy Small Apartment Buildings
        </h1>
        <p className="text-xl lg:text-2xl mb-4 max-w-4xl mx-auto">
          Duplexes, Triplexes, Quadplexes, and 5-Unit Properties
        </p>
        <p className="text-lg lg:text-xl mb-8 max-w-3xl mx-auto">
          Fast cash offers for small multifamily properties in any condition - occupied, vacant, or distressed
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#get-offer"
            className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap"
          >
            Get Your Cash Offer Now
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a 
            href="#how-it-works"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
          >
            See How It Works
          </a>
        </div>
      </div>
    </section>
  );
}